import { makeVar } from '@apollo/client';

export const MAINTENANCE_MODE_CODE = 'MAINTENANCE_MODE';

export interface MaintenanceState {
  title: string;
  message: string;
  retryAfterSeconds: number;
}

/**
 * Single source of truth for maintenance mode.
 *   null -> app runs normally
 *   MaintenanceState -> render <MaintenancePage />
 *
 * Written from two places:
 *   1. The appStatus query in MaintenanceGate (deliberate check + recovery poll)
 *   2. The errorLink in apolloClient.ts (backstop for in-flight requests)
 *
 */
export const maintenanceVar = makeVar<MaintenanceState | null>(null);

export function enterMaintenance(state: MaintenanceState): void {
  if (!maintenanceVar()) {
    maintenanceVar(state);
  }
}

export function exitMaintenance(): void {
  if (maintenanceVar()) {
    maintenanceVar(null);
  }
}

export function isMaintenanceMode(): boolean {
  return maintenanceVar() !== null;
}
